import { native } from '@forest/native-services'
import { dialog } from '@forest/shared/solid'
import { m } from '~/paraglide/messages'
import { logNonFatal } from './diagnostics'
import { loadFailureDialog } from './load-failure'

let pageLoadFailed = false

/**
 * Opens the dialog for a failed read, showing its failure code (ADR 0037). A
 * page-load failure is reported to native and closes the page, and only the
 * first one shows: when the user cannot be read, every read fails with it. A
 * read made on a tap (`closesPage: false`) leaves the page as it was.
 */
export function openLoadFailureDialog(
  error: unknown,
  { closesPage }: { closesPage: boolean },
): void {
  const { kind, code, description } = loadFailureDialog(error, {
    connection: m.dialog_connection_issue_description(),
    somethingWentWrong: m.dialog_something_went_wrong_description(),
  })
  if (closesPage) {
    logNonFatal('focus_challenge_page_load_failed', {
      reason: code,
      error: String(error),
    })
    if (pageLoadFailed) return
    pageLoadFailed = true
  }
  void dialog.open({
    ...(kind === 'connection'
      ? { title: m.dialog_connection_issue_title(), button: m.OK() }
      : {
          title: m.dialog_something_went_wrong_title(),
          button: m.btn_got_it(),
        }),
    description,
    ...(closesPage && { action: () => native.general.close() }),
  })
}
